<template>
  <b-modal
    id="modal-activitice"
    ok-title="Submit"
    cancel-variant="outline-secondary"
    centered
    body-class="common_modal modal_visible"
    hide-footer
    no-close-on-backdrop
    size="lg"
    hide-header-close
  >
  <!-- @hide="resetModal" -->
    <template #modal-header="{ close }">
      <h3 class="m-0">
        <font-awesome-icon class="mr-50" icon="fa-solid fa-person-running" />活動記錄
      </h3>
      <a @click="close()">
        <font-awesome-icon style="font-size: 20px" icon="fas fa-times" />
      </a>
    </template>
    <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
      <b-overlay
        :show="loading"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
      >
        <b-form class="mt-1" @submit.prevent="handleSubmit(onSubmit)">
          <b-row>
            <!-- activitice type -->
            <b-col cols="12" md="12">
              <validation-provider
                #default="validationContext"
                name="此欄"
                rules="required"
                vid="v_activity_type_id"
              >
                <b-form-group
                  label="活動類型："
                  label-for="activity_type_id"
                  label-cols-md="3"
                  class="required"
                >
                  <v-select
                    id="activity_type_id"
                    v-model="newActiviticeData.activity_type_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="activiticeTypeOptions"
                    :clearable="false"
                    label="name"
                    :reduce="(option) => option.id"
                    placeholder="活動類型"
                  >
                  </v-select>
                  <b-form-invalid-feedback
                    :state="getValidationState(validationContext)"
                  >
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <!-- details -->
            <b-col cols="12" md="12">
              <validation-provider
                #default="validationContext"
                name="此欄"
                rules="required"
                vid="v_details"
              >
                <b-form-group
                  label="活動內容："
                  label-for="details"
                  label-cols-md="3"
                  class="required"
                >
                  <b-form-textarea
                    id="details"
                    v-model="newActiviticeData.details"
                    placeholder="輸入活動內容"
                    rows="3"
                    :state="getValidationState(validationContext)"
                  />

                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
          

              <!-- start_date -->
              <b-col cols="12" md="12">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_start_date"
                >
                  <b-form-group
                    label="預定工期："
                    label-for="start_date"
                    label-cols-md="3"
                    class="required"
                  >
                    <flat-pickr
                      v-model="newActiviticeData.start_date"
                      class="form-control"
                      :config="{
                        allowInput: true,
                        altInput: true,
                        altFormat: 'Y-m-d',
                        dateFormat: 'Y-m-d',
                      }"
                      placeholder="輸入YYYY-MM-DD"
                    />
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- end_date -->
              <b-col cols="12" md="12">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_end_date"
                >
                  <b-form-group
                    label="至"
                    label-for="end_date"
                    label-cols-md="3"
                    class="required"
                  >
                    <flat-pickr
                      v-model="newActiviticeData.end_date"
                      class="form-control"
                      :config="{
                        allowInput: true,
                        altInput: true,
                        altFormat: 'Y-m-d',
                        dateFormat: 'Y-m-d',
                      }"
                      placeholder="輸入YYYY-MM-DD"
                    />
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

            <!-- workers -->
            <b-col cols="12" md="12">
              <validation-provider
                #default="validationContext"
                name="此欄"
                rules="required"
                vid="v_workers"
              >
                <b-form-group
                  label="負責師傅："
                  label-for="workers"
                  label-cols-md="3"
                  class="required"
                >
                  <v-select
                    id="workers"
                    class="multi-select"
                    v-model="newActiviticeData.workers"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="workerOptions"
                    multiple
                    label="name"
                    :reduce="(option) => option.id"
                    placeholder="負責師傅"
                  >
                  </v-select>
                  <b-form-invalid-feedback
                    :state="getValidationState(validationContext)"
                  >
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

          </b-row>
          <div class="d-flex mt-2 justify-content-end">
           
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              type="submit"
              class="mr-1"
            >
              <font-awesome-icon
                class="mr-25"
                icon="fa-solid fa-circle-check"
              />
              提交
            </b-button> 
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-danger"
              @click="hide"
            >
              取消
            </b-button>
          </div>
        </b-form>
      </b-overlay>
    </validation-observer>
  </b-modal>
</template>

<script>
import {
  BButton,
  BModal,
  VBModal,
  BCardText,
  BOverlay,
  BForm,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BFormFile,
  BRow,
  BCol,
  BCard,
  BCardBody,
  BFormInvalidFeedback,
  BFormCheckbox,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import flatPickr from "vue-flatpickr-component";
import store from "@/store";
import { required } from "@validations";
import { ref, watch, onUnmounted } from "@vue/composition-api";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import zh_CN from "vee-validate/dist/locale/zh_CN.json";
localize("zh_cn", zh_CN);
import formValidation from "@core/comp-functions/forms/form-validation";
import uploadFile from "@/layouts/components/file/uploadFile.vue";

export default {
  components: {
    BButton,
    BModal,
    VBModal,
    BCardText,
    BOverlay,
    BForm,
    BFormGroup,
    BFormInput,
    BFormFile,
    BRow,
    BCol,
    BCardBody,
    BCard,
    BFormInvalidFeedback,
    BFormCheckbox,
    vSelect,
    flatPickr,
    ValidationProvider,
    ValidationObserver,
    uploadFile,
    BFormTextarea
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  props: {
    activiticeTypeOptions:{},
    activiticeData:{},
    workerOptions:{},
    project_id:{},
  },
  data() {
    return {
      required,
    };
  },
  methods: {
    hide() {
      this.$bvModal.hide("modal-activitice");
    },
    resetModal(){
      this.newActiviticeData = {id:0}
    },
    onSubmit() {
      this.$swal({
        title: "你確定嗎?",
        showCancelButton: true,
        confirmButtonText: "提交",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          if(!this.newActiviticeData.project_id){
            this.newActiviticeData.project_id = this.project_id
          }
         
          store
            .dispatch("order/editProjectActivitice",this.newActiviticeData )
            .then((response) => {
              this.loading = false;
              this.$swal({
                text: response.data.message,
                icon: "success",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.$emit("refetch-data");
              this.hide()
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
  },
  setup(props) {
    const loading = ref(false);
    const newActiviticeData = ref({ id: 0 });

    const resetActiviticeData = () => {
      newActiviticeData = JSON.parse(JSON.stringify({ id: 0 }));
    };

    const { refFormObserver, getValidationState, resetForm } = formValidation(
      resetActiviticeData
    );

    watch(
      () => props.activiticeData,
      (newVal) => {
        newActiviticeData.value = JSON.parse(JSON.stringify(props.activiticeData));
        const newArray = newActiviticeData.value.workers.map(ele => ele.id)
          newActiviticeData.value.workers = newArray
        console.log(' newActiviticeData.value', newActiviticeData.value)
      },{immediate:true}
    );

    return {
      loading,
      newActiviticeData,
      refFormObserver,
      getValidationState,
      resetForm,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
// #modal-message-message {
//   .full_input label {
//     width: calc(13% - 3px);
//   }
// }
</style>
